var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-v-unlock-bar",style:(_vm.textStyle)},[_c('div',{staticClass:"c-v-unlock-bar__progress",style:(_vm.barProgressStyle)}),_vm._v(" "+_vm._s(_vm.dbEntry.format(_vm.resource))+" / "+_vm._s(_vm.dbEntry.format(_vm.dbEntry.requirement))+" "+_vm._s(_vm.dbEntry.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }